import { addDocument, deleteDocument, setDocument } from '../../services/firestore-service';

export const createProduct = payload => {
    return (dispatch) => {
        addDocument('products', payload)
            .then(() => {
                dispatch({ type: 'CREATE_PRODUCT_SUCCESS'})
            }).catch((error) => {
                dispatch({ type: 'CREATE_PRODUCT_FAILED', error});
            });
    }
}

export const updateProduct = payload => {
    return (dispatch) => {
        setDocument('products', payload.id, payload)
            .then(() => {
                dispatch({ type: 'UPDATE_PRODUCT_SUCCESS'})
            }).catch((error) => {
                dispatch({ type: 'UPDATE_PRODUCT_FAILED', error});
            });
    }
}

export const deleteProduct = id => {
    return (dispatch) => {
        deleteDocument('products', id)
            .then(() => {
                dispatch({ type: 'DELETE_PRODUCT_SUCCESS'})
            }).catch((error) => {
                dispatch({ type: 'DELETE_PRODUCT_FAILED', error});
            });
    }
}

export const updateBox = payload => {
    return (dispatch) => {
        setDocument('configurations', 'boxes', payload)
            .then(() => {
                dispatch({ type: 'UPDATE_BOXES_SUCCESS'})
            }).catch((error) => {
                dispatch({ type: 'UPDATE_BOXES_FAILED', error});
            });
    }
}

export const updateDesignHeader = payload => {
    return (dispatch) => {
        setDocument('configurations', 'design_header', payload)
            .then(() => {
                dispatch({ type: 'UPDATE_DESIGN_HEADER_SUCCESS'})
            }).catch((error) => {
                dispatch({ type: 'UPDATE_DESIGN_HEADER_FAILED', error});
            });
    }
}

export const updateHeroSlider = payload => {
    return (dispatch) => {
        setDocument('configurations', 'home_config', payload)
            .then(() => {
                dispatch({ type: 'UPDATE_HERO_SLIDER_SUCCESS'})
            }).catch((error) => {
                dispatch({ type: 'UPDATE_HERO_SLIDER_FAILED', error});
            });
    }
}

export const markMessageAsRead = payload => {
    return (dispatch) => {
        setDocument('contactForms', payload.id, payload)
            .then(() => {
                dispatch({ type: 'MESSAGE_READ_SUCCESS'})
            }).catch((error) => {
                dispatch({ type: 'MESSAGE_READ_FAILED', error});
            });
    }
}

export const markOrderAsRead = payload => {
    return (dispatch) => {
        setDocument('orders', payload.id, payload)
            .then(() => {
                dispatch({ type: 'ORDER_READ_SUCCESS'})
            }).catch((error) => {
                dispatch({ type: 'ORDER_READ_FAILED', error});
            });
    }
}
